import React, { useState } from "react";
import { MdDelete as Ico } from 'react-icons/md';
// Components
import CommonButton from "../../common/button/button";
import ModalConfirmYesNo from "../../common/modalConfirmYesNo/modalConfirmYesNo";

const ButtonDelete = ({ 
  primaryValue, 
  primaryName,
  selectedRows = [],
  config,
  itemNameSingular,
  itemIsMale = true,
  onDelete,
}) => {
  // States
  const [modalConfirmData, setModalConfirmData] = useState({});

  /*
   * Delete (ask)
   */
  const handleDelete = async () => {
    const selectedRowsCount = selectedRows.length;
    const isMultipleDelete = selectedRowsCount > 1;
    let title = 'Eliminació ';
    if (isMultipleDelete) {
      title += `de ${selectedRowsCount} registres`;
    } else {
      title += itemIsMale ? 'del' : 'de la';
      title += ` ${itemNameSingular}: ${primaryValue} - ${primaryName}`;
    }
    setModalConfirmData({
      visible: true,
      title,
      description: isMultipleDelete
        ? `Estàs segur que vols eliminar ${selectedRowsCount} registres? Aquesta acció no es podrà desfer.`
        : `Estàs segur? Aquesta acció no es podrà desfer.`,
    });
  };

  /*
   * Render
   */
  let caption = "Eliminar"
  let onClick = () => { handleDelete() };
  let width = "120px";
  let marginLeft = "0px";
  let disabled = false;
  if (!!config) {
    if (config.visible === false) return null;
    caption = config.caption || caption;
    width = config.width || width;
    marginLeft = config.marginLeft || marginLeft;
    if (config.disabled) disabled = true
  }
  
  return (
    <>
      <CommonButton 
        onClick={onClick} 
        style={{
          width,
          marginLeft,
          display: "flex", // Use flexbox to control alignment
          alignItems: "center", // Center icon and text vertically
          justifyContent: "flex-start", // Align icon and text to the left
          gap: "8px", // Add spacing between icon and text
        }}
        inverted={true}
        disabled={disabled}
      >
        <Ico size={18} />
        <span>{caption}</span>
      </CommonButton>

      {modalConfirmData.visible && (
        <ModalConfirmYesNo
          title={modalConfirmData.title}
          description={modalConfirmData.description}
          isOpen={modalConfirmData.visible}
          onClose={() => setModalConfirmData({})}
          handleClose={(confirm) => {
            if (confirm) {
              onDelete();
            }
            setModalConfirmData({});
          }}
        />
      )}
    </>

  );
};

export default ButtonDelete;
